import {queryAccountInfo} from '@api/core/user';
import localDb from '@util/localDb';

// 按模块的action, reducer整合体
const ACCOUNT_INFO = 'ACCOUNT_INFO';

const judgeRole = info => {
  // 判断是否有财务管理的权限
  const isFinancialM = info.roles.some(item => {
    return item === '[FinanceMenber]';
  });
  // 判断是否总经理
  const isComLeader = info.roles.some(item => {
    return item === '[ComLeader]';
  });
  // 判断是孵化器管理员（众客）
  const isHatcherMng = info.roles.some(item => {
    return item === '[HatcherMng]';
  });
  // 判断是孵化器管委会秘书
  const isIncubatorMng = info.roles.some(item => {
    return item === '[IncubatorMng]';
  });
  // 判断是孵化器人员）
  const isIncubatorEdit = info.roles.some(item => {
    return item === '[IncubatorEdit]';
  });
  return {
    isFinancialM,
    isComLeader,
    isHatcherMng,
    isIncubatorMng,
    isIncubatorEdit,
  };
};

export function getAccountInfo() {
  return dispatch => {
    return queryAccountInfo().then(res => {
      if (res.statusCode === 200) {
        const roles = judgeRole(res.data);
        localDb.set(ACCOUNT_INFO, {
          ...res.data,
          ...roles,
        });
        localDb.set('userUuid', res.data.userUuid);
        return dispatch({
          type: ACCOUNT_INFO,
          data: {
            ...res.data,
            ...roles,
          },
        });
      }
    });
  };
}

// Reducer
export const accountInfo = (state = {}, action) => {
  switch (action.type) {
    case ACCOUNT_INFO:
      return action.data;
    default:
      return localDb.get(ACCOUNT_INFO);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/account_info.js